var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInternationalPassportFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 139,
    viewBox: "0 0 122 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#international_passport_filled_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 25,
    width: 42,
    height: 53.455,
    rx: 4,
    fill: "#005FF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.876 49.409l-2.902-1.458a.855.855 0 01-.46-.626.855.855 0 01.24-.738l.444-.444a.853.853 0 01.63-.25l2.995.094 1.446-1.445-5.58-3.4a.849.849 0 01-.158-1.32c.142-.14.283-.28.402-.4a.846.846 0 01.771-.23l7.788 2.127 2.807-2.807a1.75 1.75 0 012.473 0 1.75 1.75 0 010 2.474l-2.807 2.806 2.127 7.788a.845.845 0 01-.23.772l-.4.4a.848.848 0 01-1.32-.158l-3.4-5.579-1.444 1.445.098 2.99a.855.855 0 01-.248.63l-.45.45a.855.855 0 01-.739.24.855.855 0 01-.626-.46l-1.457-2.901z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.284,
    y: 67.045,
    width: 14.25,
    height: 2.591,
    rx: 1.295,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.284,
    y: 61.864,
    width: 19.432,
    height: 2.591,
    rx: 1.295,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 23.496h29.258l-.007-.05a4 4 0 00-4.515-3.407L46 23.496z",
    fill: "#005FF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "international_passport_filled_svg__filter0_d",
    x: 0,
    y: 0,
    width: 122,
    height: 138.455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgInternationalPassportFilled as ReactComponent };